import { event, oneOf } from "../schema-util";

import { noProps } from "./shared";

/**
 * Settings related events.
 *
 * Events are prefixed with "settings." followed by a set of location or action descriptors.
 */
export const settings = {
  "settings.account.subscription.premises.insights.clicked": event({
    source: oneOf(["base", "datapack"]).describe("Which of the insights links was clicked"),
  }).describe("User clicked the insights link on the premises panel"),
  "settings.account.subscription.licenses.manage.clicked": noProps.describe("User clicked the Manage users link on the licenses panel"),
  "settings.account.subscription.manage.clicked": noProps.describe("User clicked the Manage subscription link"),

  // Top nav settings/profile items
  "topbar.settings.clicked": noProps.describe("Clicked on the 'Settings' link in the top nav bar"),
  "topbar.settings.menu.opened": noProps.describe("Opened the profile menu in the top nav"),
  "topbar.settings.menu.system-admin.clicked": noProps.describe("Clicked on the system admin item in the top nav profile menu"),
  "topbar.settings.menu.create-account.clicked": noProps.describe("Clicked on the create account item in the top nav profile menu"),
  "topbar.settings.menu.sign-out.clicked": noProps.describe("Clicked on the sign out item in the top nav profile menu"),
  "topbar.settings.menu.switch-account.item.selected": noProps.describe("Selected an account in the switch account menu in the top nav profile menu"),
  "topbar.settings.menu.switch-account.create-account.clicked": noProps.describe(
    "Clicked on the create account item in the switch account menu in the top nav profile menu"
  ),

  // settings page views.
  // In these cases a "click" on the respective button that navigates to that view is tracked as a "view"
  "settings.profile.details.viewed": noProps.describe("Views the user's details page"),
  "settings.profile.change-password.viewed": noProps.describe("Views the user's change password page"),
  "settings.profile.account-invites.viewed": noProps.describe("Views the user's pending invites page"),
  "settings.account.details.viewed": noProps.describe("Views the account details page"),
  "settings.account.subscription.viewed": noProps.describe("Views the account subscription settings page"),
  "settings.account.defaults.viewed": noProps.describe("Views the account defaults settings page"),
  "settings.users.userlist.viewed": noProps.describe("Views the user management list page"),
  "settings.users.invites.viewed": noProps.describe("Views the user management pending invites page"),
  "settings.insights.overview.viewed": noProps.describe("Views the insights overview page"),
};
